import React, { useEffect, useState } from 'react';

const DISMISS_KEY = 'pwaInstallDismissedUntil';
const DISMISS_DAYS = 7; // hide for 7 days when user closes

export const PwaInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function beforeInstallHandler(e) {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      setDeferredPrompt(e);

      const dismissedUntil = parseInt(localStorage.getItem(DISMISS_KEY) || '0', 10);
      if (dismissedUntil && dismissedUntil > Date.now()) return; // respect dismissal

      setVisible(true);
    }

    function appInstalledHandler() {
      // Hide UI when installed
      setVisible(false);
      setDeferredPrompt(null);
    }

    window.addEventListener('beforeinstallprompt', beforeInstallHandler);
    window.addEventListener('appinstalled', appInstalledHandler);

    return () => {
      window.removeEventListener('beforeinstallprompt', beforeInstallHandler);
      window.removeEventListener('appinstalled', appInstalledHandler);
    };
  }, []);

  const closePrompt = () => {
    // dismiss for a week
    const until = Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000;
    localStorage.setItem(DISMISS_KEY, String(until));
    setVisible(false);
  };

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const choiceResult = await deferredPrompt.userChoice;
    if (choiceResult && choiceResult.outcome === 'accepted') {
      // user accepted
      setVisible(false);
      localStorage.removeItem(DISMISS_KEY);
    } else {
      // user declined
      closePrompt();
    }
    setDeferredPrompt(null);
  };

  if (!visible) return null;

  return (
    <div style={containerStyle} role="dialog" aria-live="polite">
      <div style={innerStyle}>
        <div style={leftStyle}>
          <img src="/logo192.png" alt="Gosafe" style={iconStyle} />
        </div>
        <div style={contentStyle}>
          <div style={{ fontWeight: 600 }}>Instalar Gosafe</div>
          <div style={{ fontSize: 12, opacity: 0.9 }}>Instálala para acceder rápido y sin conexión.</div>
        </div>
        <div style={actionsStyle}>
          <button style={installButtonStyle} onClick={handleInstall} aria-label="Instalar">
            Instalar
          </button>
          <button style={closeButtonStyle} onClick={closePrompt} aria-label="Cerrar">
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

// Inline styles (small and unobtrusive)
const containerStyle = {
  position: 'fixed',
  right: 16,
  bottom: 16,
  zIndex: 9999,
};

const innerStyle = {
  display: 'flex',
  alignItems: 'center',
  background: '#fff',
  color: '#111',
  borderRadius: 10,
  padding: '8px 10px',
  boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
  minWidth: 260,
  gap: 8,
  border: '1px solid rgba(0,0,0,0.06)'
};

const leftStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const iconStyle = {
  width: 40,
  height: 40,
  borderRadius: 8,
};

const contentStyle = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
};

const actionsStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
};

const installButtonStyle = {
  background: '#007bff',
  color: '#fff',
  border: 0,
  borderRadius: 6,
  padding: '6px 10px',
  cursor: 'pointer',
  fontWeight: 600,
  fontSize: 13,
};

const closeButtonStyle = {
  background: 'transparent',
  border: 0,
  color: '#666',
  cursor: 'pointer',
  fontSize: 16,
  lineHeight: 1,
};

export default PwaInstallPrompt;